import { useMemo } from 'react';
import { useMsal } from '@azure/msal-react';
import { apiTokenRequest, apiConfig } from '../authConfig';
import { createSupportApi } from '../utils/supportApi';

/** Memoised typed client for /support/tickets*, /admin/support/routing-rules and /sqa*. */
export function useSupportApi() {
    const { instance, accounts } = useMsal();
    return useMemo(
        () =>
            createSupportApi(async () => {
                const res = await instance.acquireTokenSilent({ ...apiTokenRequest, account: accounts[0] });
                return res.accessToken;
            }, apiConfig.baseUrl),
        [instance, accounts],
    );
}
